import React from "react";
import { ArrowUpRight } from "lucide-react";

interface ModalityCardProps {
  title: string;
  description: string;
  link: string;
  imageUrl: string;
}

const ModalityCard: React.FC<ModalityCardProps> = ({ title, description, link, imageUrl }) => {
  return (
    <a href={link} className="group block h-full">
      <article className="relative flex h-full min-h-72 flex-col justify-end overflow-hidden rounded-md bg-teal-950 p-5 shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
        <img src={imageUrl} alt="" className="absolute inset-0 h-full w-full object-cover opacity-75 transition duration-500 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)] via-[var(--ink)]/45 to-transparent" />
        <div className="relative">
          <span className="rounded-full bg-[var(--accent)] px-3 py-1 text-xs font-black uppercase tracking-[0.14em] text-[var(--ink)]">
            Ruta formativa
          </span>
          <h3 className="mt-4 text-2xl font-black leading-tight text-white">{title}</h3>
          <p className="mt-2 text-sm leading-6 text-white/82">{description}</p>
          <span className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-bold text-[var(--ink)]">
            Ver cursos <ArrowUpRight className="h-4 w-4 transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </div>
      </article>
    </a>
  );
};

export default ModalityCard;
